import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserData } from '../../providers/user-data'
import { OrganisationData } from '../../providers/organisation-data'
import { GlobalVariable } from '../../global'
import { Storage } from '@ionic/storage';
import { UpdateUserFormPage } from '../update-user-form/update-user-form'
import { AlertController } from 'ionic-angular';
import { HomePage } from '../home/home';
/**
 * Generated class for the MentorListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-mentor-list',
  templateUrl: 'user-list.html',
})
export class UserListPage {
  users: any
  usertype: any
  organisations: any
  displayusers: any;
  constructor(public navCtrl: NavController, public alertCtrl: AlertController, public navParams: NavParams, private userData: UserData, private storage: Storage,
    private organisationData: OrganisationData) {
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      if (this.usertype != GlobalVariable.Admin) {
        this.navCtrl.setRoot(HomePage);
      }
    });
  }

  ionViewDidLoad() {
    this.getUserList()
    this.getOrganisation()
  }
  getUserList() {
    this.userData.getUserListByOrganisationId().subscribe(
      res => {
        if (res['success']) {
          this.users = res['data']
          if (this.usertype == GlobalVariable.Admin) {
            this.users = this.users.filter(item => item.usertype != GlobalVariable.Admin)
          }
          this.users.map(item => {
            if (item.usertype == GlobalVariable.Admin) {
              item.usertypename = 'Admin'
            } else if (item.usertype == GlobalVariable.Mentor) {
              item.usertypename = 'Mentor'
            } else if (item.usertype == GlobalVariable.Mentee) {
              item.usertypename = 'Mentee'
            }
          })
        }
      },
      err => {
        this.presentAlert('Error', 'something went wrong, try again')
      }
    )
  }

  getOrganisation() {
    this.organisationData.getOrganisation().subscribe(
      res => {
        this.organisations = res['data']
      },
      err => {
        this.presentAlert('Error', 'something went wrong, try again')
      }
    )
  }

  doRefresh(refresher) {
    this.getUserList()
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }

  onClickOnView(item) {
    this.navCtrl.push(UpdateUserFormPage, {
      userid: item.userid,
      usertype: item.usertype
    })
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

  searchCustomer(event) {
    this.displayusers = [];
    const val = event.target.value;
    if (val && val.length > 3) {
      this.displayusers = this.users.filter(p => p.surname.toLowerCase().startsWith(val.toLowerCase()) ||
                          p.forename.toLowerCase().startsWith(val.toLowerCase()));
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-list/user-list.ts